import { motion } from 'framer-motion';

/**
 * Standardized page header that matches the Dashboard's redesigned visual language.
 * - Large Manrope navy title (matches Dashboard h1)
 * - Subtle muted subtitle
 * - Optional right-side actions slot
 */
export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div
      className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between"
      data-testid={testId}
    >
      <motion.div initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="font-['Manrope'] text-2xl font-extrabold tracking-tight text-[#2B3674] sm:text-3xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-1 text-sm text-[#A3AED0] sm:text-[15px]">{subtitle}</p>
        ) : null}
      </motion.div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export default PageHeader;
